module.exports = __webpack_public_path__ + "img/wochenblatt-freies-denken.70c15db9.jpg";